/**
 * @class FuzzySearchService
 * @description Service for fuzzy search on products, pages, and tags
 */
class FuzzySearchService {
    constructor() {
        this.allTags = [];
        this.fuseTags = null;
    }

    async searchProducts(searchTerm, limit = 10) {
        try {
            let page = 1;
            let hasMore = true;
            const tagsSet = new Set();
            const allProducts = [];

            while (hasMore) {
                const response = await fetch(`/products.json?limit=250&page=${page}`);
                if (!response.ok) {
                    throw new Error(`Failed to fetch products: ${response.status}`);
                }
                const data = await response.json();

                if (!data.products || data.products.length === 0) {
                    hasMore = false;
                } else {
                    data.products.forEach(product => {
                        allProducts.push(product);

                        if (product.tags) {
                            const tagArray = Array.isArray(product.tags)
                                ? product.tags
                                : product.tags.split(',');

                            tagArray.forEach(tag => {
                                const trimmed = tag.trim();
                                if (trimmed) tagsSet.add(trimmed);
                            });
                        }
                    });

                    if (data.products.length < 250) hasMore = false;
                    page++;
                }
            }

            this.allTags = Array.from(tagsSet).sort();
            this.fuseTags = new Fuse(this.allTags, { threshold: 0.4 });

            const fuse = new Fuse(allProducts, {
                keys: ['title', 'tags', 'product_type', 'vendor'],
                threshold: 0.4
            });

            return fuse.search(searchTerm).slice(0, limit).map(res => res.item);

        } catch (error) {
            console.error('Fuzzy product search error:', error);
            return [];
        }
    }

    async searchPages(searchTerm, limit = 5) {
        try {
        const response = await fetch(`/pages.json`);
        if (!response.ok) { 
            throw new Error('Failed to fetch pages: ', response.status); 
        }
        const data = await response.json();
        
        if (!data.pages || data.pages.length === 0) return [];
        
        const fuse = new Fuse(data.pages, { 
            keys: ['title'], 
            threshold: 0.4 
        });
        
        return fuse.search(searchTerm).slice(0, limit).map(res => res.item);
        } catch (error) {
        console.error('Fuzzy pages search error:', error);
        return [];
        }
    }

    searchTags(searchTerm, limit = 10) {
        if (!searchTerm || !this.fuseTags) {
        return [];
        }
        
        return this.fuseTags.search(searchTerm).slice(0, limit).map(result => result.item);
    }

    async performSearch(searchTerm) {
        const [products, pages] = await Promise.all([
        this.searchProducts(searchTerm),
        this.searchPages(searchTerm)
        ]);
        const tags = this.searchTags(searchTerm);

        return { products, pages, tags };
    }
}